import type { DefaultOptions } from "@apollo/client";

import { type Locale, serializeLocaleToBCP47, DEFAULT_LOCALE } from "../../../shared/I18n";

import { useMemo } from "react";
import { Platform } from "react-native";

interface ApolloDefaultOptionsParams {
  ctk?: string | null;
  locale?: Locale | null;
}

/**
 * Apollo configuration for ViewJob RN app.
 * Sets the indeed-ctk header so that GraphQL requests on web include the CTK
 * (on native the native networking layer attaches it automatically).
 */
export const useGetApolloDefaultOptions: (
  params?: ApolloDefaultOptionsParams,
) => DefaultOptions = ({ ctk, locale } = {}) => {
  const subApp = Platform.select({
    web: "rnviewjob-web",
    ios: "rnviewjob-ios",
    android: "rnviewjob-android",
    default: "rnviewjob",
  });

  const { country, language } = locale ?? DEFAULT_LOCALE;

  const headers = useMemo(() => {
    return {
      "indeed-client-sub-app": subApp,
      "indeed-ctk": ctk ?? "",
      "indeed-co": country,
      "indeed-locale": serializeLocaleToBCP47({ country, language }),
    };
  }, [subApp, ctk, country, language]);

  return useMemo(() => {
    return {
      watchQuery: {
        context: {
          headers: headers,
        },
      },
      query: {
        context: {
          headers: headers,
        },
      },
      mutate: {
        context: {
          headers: headers,
        },
      },
    };
  }, [headers]);
};
